import useLogoutQuery from "../api/useLogoutQuery";
import useAuth from "./useAuth";

export default function useLogout() {
    const { onLogout } = useAuth();
    const { loading, error, logout } = useLogoutQuery();

    const logoutCallback = async () => {
        await logout();
        onLogout();
    };

    return {
        loading,
        error,
        logout: logoutCallback,
    };
}
